module.exports = __webpack_public_path__ + "img/gear-H_70x70.f405fa33.png";